module.exports = __webpack_public_path__ + "img/horizontal_2_1_r_0.539afbf9.png";